/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="67.8"
        viewBox="0 0 82.25 67.8"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M81 5.86a1.25 1.25 0 0 1 .13 2.49H32.76a1.25 1.25 0 0 1-.13-2.49H81ZM20.33 5.86a1.25 1.25 0 0 1 .17 2.49H1.25a1.25 1.25 0 0 1-.13-2.49h19.21Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M26.58 0a7.11 7.11 0 1 0 7.11 7.11A7.11 7.11 0 0 0 26.58 0Zm0 2.5a4.61 4.61 0 1 1-4.61 4.61 4.61 4.61 0 0 1 4.61-4.61Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M81 59.44a1.25 1.25 0 0 1 .13 2.49H32.69a1.25 1.25 0 0 1-.13-2.49H81ZM20.4 59.44a1.25 1.25 0 0 1 .12 2.49H1.25a1.25 1.25 0 0 1-.13-2.49H20.4ZM48.99 32.65a1.25 1.25 0 0 1 .13 2.49H1.25a1.25 1.25 0 0 1-.13-2.49h47.87ZM81 32.65a1.25 1.25 0 0 1 .13 2.49h-19.8a1.25 1.25 0 0 1-.13-2.49H81Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M55.17 26.79a7.11 7.11 0 1 0 7.11 7.11 7.11 7.11 0 0 0-7.11-7.11Zm0 2.5a4.61 4.61 0 1 1-4.61 4.61 4.6 4.6 0 0 1 4.61-4.61ZM26.58 53.58a7.11 7.11 0 1 0 7.11 7.11 7.11 7.11 0 0 0-7.11-7.11Zm0 2.5a4.61 4.61 0 1 1-4.61 4.61 4.61 4.61 0 0 1 4.61-4.61Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'SettingsSliderIcon';

export default Icon;
